<template>
  <div>
    <div class="mt-2">
      <form data-vv-scope="comment-management">
        <vs-textarea
          class="mb-2"
          maxlength="1000"
          counter="1000"
          label="Comentario"
          v-model="comment"
          name="comment"
        />
        <div v-if="errors.first('comment-management.comment')"
             class="con-text-validation span-text-validation-danger
           vs-input--text-validation-span v-enter-to"
             style="height: 20px;">
          <span class="span-text-validation">
            {{errors.first('comment-management.comment')}}
          </span>
        </div>
      </form>
      <div class="my-5 text-right" v-if="enableAttachButton">
        <UploadMultipleFiles
          permission="*"
          text="Agregar"
          v-model="file"
          :upload-to="urlFile"
          type-button="small"
          button-class=""
          container-class="text-right"
          @input="addAdditionalFile()"
        />
      </div>
      <div class="row">
        <div class="col-2" v-for="file in commentFiles" :key="file.id">
          <div class="d-flex flex-column align-items-center">
            <vs-icon icon="description" size="30px" color="primary" />
            <b class="text-truncate w-100 text-center">
              {{ file.name }}
            </b>
            <vs-button
              color="danger"
              type="flat"
              icon="clear"
              @click="removeAdditionalFile(file.id)"
            />
          </div>
        </div>
      </div>
      <div class="text-right mt-4">
        <b-button
          variant="primary"
          @click="sendAction()"
        >
          Devolver
        </b-button>
      </div>
    </div>
  </div>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';
import {
  VBToggle,
  VBModal
} from 'bootstrap-vue';
import Ripple from 'vue-ripple-directive';

import UploadMultipleFiles from '@/febos/global/_vue/componentes/UploadMultipleFiles';
import { stepTypesCode } from '@/febos/chile/approvals/components/trays/managementTray/constants';

export default {
  components: {
    UploadMultipleFiles
  },
  data() {
    return {
      error: {
        message: ''
      },
      comment: '',
      file: {},
      commentFiles: [],
      resendSubject: {
        type: stepTypesCode.usuario,
        continueFlow: false
      }
    };
  },
  computed: {
    ...mapGetters('Empresas', [
      'userSignConfiguration',
      'company'
    ]),
    urlFile() {
      return `febos-io/global/${process.env.VUE_APP_AMBIENTE}/empresas/aprobaciones/${this.flowId}/comentarios`;
    },
    enableAttachButton() {
      return !this.isSiss;
    },
    isSiss() {
      return this.company.iut === '61221000-4';
    }
  },
  methods: {
    ...mapActions('Approvals', [
      'commentFileFlow',
      'processFileFlow'
    ]),
    cancelProcess() {
      this.file = [];
    },
    async validateForm(scope) {
      const result = await this.$validator.validateAll(scope);
      return !!result;
    },
    makeObjectRequest() {
      const request = {
        idEjecucion: this.flowId,
        idAprobacion: this.fileId,
        pasoId: this.stepId.id
      };

      const actions = {
        approve: 'aprobar',
        reject: 'rechazar',
        return: 'devolver',
        comment: 'comentario',
        resend: 'reenviar'
      };

      const body = {
        comentario: {
          accion: actions[this.action],
          comentario: this.comment
        },
        documentos: this.commentFiles && this.commentFiles.map((file) => ({
          tipo: actions[this.action],
          nombre: file.name,
          adjuntoId: file.id,
          adjuntoUrl: file.path,
          adjuntoMime: file.mime,
          adjuntoEstado: 2
        }))
      };
      body.estado = actions[this.action].toUpperCase();
      body.temporalUsuario = '';
      body.temporalUsuarioId = '';
      body.temporalContinuar = false;
      return { request, body };
    },
    async sendAction() {
      const isValid = await this.validateForm('comment-management');
      if (!isValid) {
        return;
      }
      const response = await this.processFileFlow(this.makeObjectRequest());
      this.$bvToast.toast(
        `${response.mensaje}`,
        {
          title: '¡Genial!',
          variant: 'primary',
          pauseOnHover: true,
          solid: true,
          noAutoHide: true
        }
      );
      this.file = [];
      this.$emit('close');
    },
    async addAdditionalFile() {
      if (!Object.keys(this.file).length) {
        return;
      }

      if (this.file.failed) {
        // TODO: display error message.
        this.error.message = 'La carga del archivo falló, inténtalo de nuevo';
        return;
      }

      this.commentFiles.push(this.file);
      this.file = [];
      await this.$validator.reset();
    },
    removeAdditionalFile(fileId) {
      this.commentFiles = this.commentFiles.filter((file) => file.id !== fileId);
      this.file = this.file.filter((file) => file.id !== fileId);
    }
  },
  props: {
    action: { type: String, required: true },
    stepId: { type: Object, required: false },
    fileId: { type: String, required: true },
    flowId: { type: String, required: true }
  },
  directives: {
    'b-toggle': VBToggle,
    Ripple,
    'b-modal': VBModal
  },
};
</script>
